import { EmployeeInterface } from "../../../common/interfaces/EmployeeInterface";
import { getUserFullName } from "../../../common/utils/getUserFullName";
import { format } from "date-fns";
import { EmployeeInfoCardsItem } from "@hatch-digital-nl/abs-storybook/legacy";

export const getEmployeeDetailItems = (
    employeeData: EmployeeInterface,
): EmployeeInfoCardsItem[] => [
    {
        label: "Naam",
        value: getUserFullName(employeeData.user),
    },
    {
        label: "Medewerker ID",
        value: employeeData.employee_id?.toString() || "-",
    },
    {
        label: "Functiegroep(en)",
        value: employeeData.function_groups
            .map((group) => group.name)
            .join(", "),
    },
    {
        label: "Geboortedatum",
        value: employeeData.date_of_birth
            ? format(new Date(employeeData.date_of_birth), "dd-MM-yyyy")
            : undefined,
    },
    {
        label: "Geboorteplaats",
        value: employeeData.place_of_birth,
    },
    {
        label: "Privé e-mail",
        value: employeeData.user.private_email,
    },
    {
        label: "Zakelijke e-mail",
        value: employeeData.person.business_email,
    },
    {
        label: "Telefoonnummer",
        value: employeeData.person.mobile_number?.toString() ?? "-",
    },
    {
        label: "Vestiging",
        value: employeeData.establishment.name,
    },
    {
        label: "In dienst",
        value: employeeData.employed_since
            ? format(new Date(employeeData.employed_since), "dd-MM-yyyy")
            : undefined,
    },
];
// EOF
